import { useState } from 'react'
import { API_URL } from '../environment'
import { handleAuthentication } from '../utils/auth'
import { getTracking } from '../utils/tracking'

const post = (url, payload) => {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(resp => {
    return resp
      .json()
      .then(json => (resp.ok ? json : Promise.reject(json.error)))
  })
}

const useApi = () => {
  const [loading, setLoading] = useState(false)

  const registerUser = ({ email, password }, next) => {
    const tracking = getTracking()
    setLoading(true)
    return post(`${API_URL}/users/register`, { email, password, tracking })
      .then(data => {
        const { user, login_url } = data
        handleAuthentication({ user, login_url, isNew: true, next })
        return user
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return { registerUser, loading }
}

export default useApi
